import React, { useState, useContext, useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';

import { Auth } from 'aws-amplify';
import { setJwt } from './services/httpService';

import { UserContext } from './context/UserState';

import ProtectedRoute from './protectedRoute';
import ProtectedRouteFromLoggedInUser from './protectedFromLoggedInUserRoute';

import {
	PORTFOLIO_PATH,
	USER_LOGIN_PATH,
	USER_REGISTER_PATH,
	CONTACT_PATH,
	USER_PROFILE_PATH,
	DASHBOARD_PATH,
	NOT_FOUND_PATH,
	HOMEPAGE_PATH,
	CONDITIONS_PATH,
	IMPRINT_PATH,
	PRIVACY_POLICY_PATH,
} from './routes';

import PageDashboard from './pages/PageDashboard';
import PageLogin from './pages/PageLogin';
import PageRegister from './pages/PageRegister';
import Page404 from './pages/Page404';
import PageProfile from './pages/PageProfile';
import PageContact from './pages/PageContact';
import PageHome from './pages/PageHome';
import PagePortfolio from './pages/PagePortfolio';
import PageConditions from './pages/pageConditions';
import PageImprint from './pages/PageImprint';
import PagePrivacy from './pages/PagePrivacy';

const AppRoutes = () => {
	const [openLoginModal, setOpenLoginModal] = useState(true);
	const [openRegisterModal, setOpenRegisterModal] = useState(true);
	const { user, setUser } = useContext(UserContext);
	const params = new URLSearchParams(useLocation().search);

	useEffect(() => {
		Auth.currentSession();
		Auth.currentAuthenticatedUser()
			.then((awsUser) => {
				setJwt(awsUser.signInUserSession.idToken.jwtToken);
				setUser({
					...user,
					username: awsUser.username,
					email: awsUser.attributes.email,
					phone: awsUser.attributes['custom:phone'],
					companyName: awsUser.attributes['custom:companyName'],
					firstNameLastName: awsUser.attributes['custom:firstNameLastName'],
					newsletter:
						awsUser.attributes['custom:Newsletter'] === 'true' ?? true,
					isLoggedIn: true,
				});
			})
			.catch((err) => console.log(err));
		// eslint-disable-next-line
	}, []);

	return (
		<Switch>
			<Redirect from="/" exact to={PORTFOLIO_PATH} component={PagePortfolio} />
			<ProtectedRouteFromLoggedInUser path={HOMEPAGE_PATH} component={PageHome} />
			<Route path={CONDITIONS_PATH} component={PageConditions} />
			<Route path={IMPRINT_PATH} component={PageImprint} />
			<Route path={PRIVACY_POLICY_PATH} component={PagePrivacy} />
			<Route path={CONTACT_PATH} component={PageContact} />
			<ProtectedRoute path={PORTFOLIO_PATH} component={PagePortfolio} />
			<Route
				path={USER_LOGIN_PATH}
				render={(props) => (
					<PageLogin
						confirmCode={params.get('code')}
						userName={params.get('user_name')}
						openModal={openLoginModal}
						closeModal={() => setOpenLoginModal(!openLoginModal)}
						{...props}
					/>
				)}
			/>
			<Route
				path={USER_REGISTER_PATH}
				render={(props) => (
					<PageRegister
						openModal={openRegisterModal}
						closeModal={() => setOpenRegisterModal(!openRegisterModal)}
						{...props}
					/>
				)}
			/>

			<ProtectedRoute path={USER_PROFILE_PATH} component={PageProfile} />
			<Route exact path="/theme/:themeID" component={PagePortfolio} />
			<Route
				exact
				path={`${DASHBOARD_PATH}/:projectID`}
				component={PageDashboard}
			/>
			<Route exact to={NOT_FOUND_PATH} component={Page404} />
			<Route component={Page404} />
		</Switch>
	);
};

export default AppRoutes;
